type ErrorMessages = {description: string;}


const errorCodeDescription:Record<string, ErrorMessages>={
    V102:{
        description: "Unique session ID generation failed"
    },
    V103:{
        description: "Inspera token validation failure at CMST"
    },
    V110:{
       description: "Lex connectivity check failed"
    },
    V111:{
        description: "Inspera failed to respond to test closure message"
    },
    V201:{
        description: "Failure on font size selection screen"
    },
    V202:{
        description: "Failure on colour contrast screen"
    },
    V302:{
        description:"Complete test recording failed to upload"
    },
    V303:{
        description:"Failure at test progression logs API"
    },
    V401:{
        description: "Base content API failure (part 1)"
    },
    V402:{
        description:"Extend Content API failure (part 2 & part 3 content)"
    },
    V403:{
        description:"Probe API failure"
    },
    V404:{
        description:"Failure at ATC tracking exposure API"
    }
};

export default errorCodeDescription;